RivalIQ.apps.Insights.module('widgets.media.utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    utils.MAX_BODY_LENGTH = 150;
    utils.MAX_LINK_TITLE_LENGTH = 60;

    const fromPropsKeys = [
        'instanceId',
        'orderBy',
        'sortOrder',
        'limit',
        'mediaTypeFilter',
        'tweetTypeFilter',
        'postTagsLimit',
        'postTagsIds',
        'objectType',
        'searchTerm'
    ];

    function navToFacebookPost(dashboardModel, post) {
        const router = dashboardModel.getCuration().router;

        const isReel = (_.get(post, ['rivaliq', 'display', 'type']) === 'reel');

        const detailsProps = {
            companyId: dashboardModel.getProp('companyId') || post.company_id,
            postId: post.facebook_post_id,
            objectType: (isReel ? 'reel' : 'post'),
            fromCuration: RivalIQ.enums.curation.FACEBOOK_INSIGHTS_POSTS
        };

        if (dashboardModel.isFocus()) {
            detailsProps.from = dashboardModel.getProp('instanceId');
            detailsProps.fromProps = _.pick(dashboardModel.getProps(), fromPropsKeys);
        }

        let curation = RivalIQ.enums.curation.FACEBOOK_INSIGHTS_POST_DETAILS;
        if (isReel) {
            curation = RivalIQ.enums.curation.FACEBOOK_INSIGHTS_REEL_DETAILS;
        }

        const path = router.resolveCurationRoute(curation, detailsProps);

        return RivalIQ.execute('history:navigate', path, {
            trigger: true
        });
    }

    utils.showDetails = function (dashboardModel, post, metric, postTagsById) {

        if (metric.get('source') === RivalIQ.enums.sources.FACEBOOK_INSIGHTS) {
            return navToFacebookPost(dashboardModel, post);
        }

        const objectType = dashboardModel.getProp('objectType');

        const config = {};
        config[objectType] = post.id;

        // Null out any name that might be set on metric; otherwise, all the metrics in the modal
        // will have their name overridden. See #28280
        config.name = null;

        let modalTitle;
        if (objectType === RivalIQ.enums.insightsObjectType.post) {
            modalTitle = 'Post Details';
        } else {
            modalTitle = 'Frame Details';
        }

        const metaMetrics = [
            {
                property: 'icon_url',
                dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
            }
        ];
        const props = dashboardModel.getProps();

        let builtMetric;
        if (props.useUniversalMetricsApi) {
            props.useUniversalMetricsApi = false;
            props.objectType = RivalIQ.enums.insightsObjectType.post;
            metric = new RivalIQ.models.MetricDefinition(RivalIQ.apps.Insights.utils.createInsightsMetric(props.objectType, props));
            config.dimensions = [];
            builtMetric = metric.build(config, {
                clobberDimensions: true
            });
        } else {
            builtMetric = metric.build(config);
        }

        RivalIQ.execute('show:modal', {
            size: 'large',
            className: 'post-modal',
            tracking: {
                options: {
                    channel: dashboardModel.getProp('channel'),
                    objectType: dashboardModel.getProp('objectType')
                },
                metric: RivalIQ.tracking.metric.ViewedInsightsPostModal
            },
            information: {
                title: modalTitle
            },
            contentView: new App.views.InstagramMediaObject({
                postTagsById: postTagsById,
                dashboardModel: dashboardModel,
                metric: builtMetric,
                model: new Backbone.Model(post),
                collection: new RivalIQ.collections.MetricDefinitions(
                    _.map(metaMetrics, function (metric) {
                        return RivalIQ.metric.build(metric, props);
                    })
                )
            })
        });
    };

    utils.navToStoryDay = function (dashboardModel, storyDay) {
        const props = {
            storyDay: storyDay,
            presenceId: dashboardModel.getProp('presenceId'),
            companyId: dashboardModel.getProp('companyId'),
            searchTerm: dashboardModel.getProp('searchTerm')
        };

        // NOTE when we are dealing with a read only user we can't let them
        // pass out of Custom Dashboards
        if (RivalIQ.state.user.isReadOnly()) {
            return;
        }

        if (dashboardModel.getProp('instanceId')) {
            props.fromProps = _.pick(dashboardModel.getProps(), fromPropsKeys);
        }

        const router = _.get(dashboardModel, ['curation', 'router'], dashboardModel.router);
        const path = router.resolveCurationRoute(RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_STORY_DAY, props);

        if (dashboardModel.curation.isCustomDashboard) {
            window.open(path, '_blank');
        } else {
            Backbone.history.navigate(path, {
                trigger: true
            });
        }
    };

    utils.wrapLoadDataForCustomDashboards = function (fn) {
        return function () {
            const me = this;

            const widget = (me.dashboardModel || me);
            const curation = widget.getCuration();

            if (!curation.isCustomDashboard || !widget.instanceId) {
                return fn.apply(me, arguments);
            }

            return RivalIQ.apps.Insights.widgets.MediaWidget.prepare(widget.getProps())
                .then(function (results) {
                    curation.presence = results.presence;

                    let shouldLoadData = true;
                    const companies = _.get(results, ['metadata', 'companies']);
                    const landscapeCompanies = _.reduce(companies, function (memo, presence) {
                        const company = RivalIQ.state.landscape.get('companies').get(presence.id);
                        return (company ? memo.concat(presence.id) : memo);
                    }, []);

                    const companyId = me.getProp('companyId');
                    if (companyId) {
                        const source = widget.getProp('source');
                        shouldLoadData = (!RivalIQ.props.channelRedacted(widget.getProps(), source) && landscapeCompanies.indexOf(companyId) >= 0);

                        if (!shouldLoadData) {
                            me.collection = new Backbone.Collection();
                            me._no_load_attempted = true;
                            return $.when();
                        }
                    } else {
                        if (_.isEmpty(landscapeCompanies)) {
                            me._no_load_attempted = true;
                            return fn.apply(me, arguments);
                        }
                    }

                    me._no_load_attempted = false;
                    return fn.apply(me, arguments);
                });
        };
    };

    utils.getSortProperties = function (dashboardModel, objectType) {
        return App.utils.getSortableProperties(dashboardModel.getProp('source'), objectType, {
            hasPaidEngagement: App.utils.hasInstagramPaidEngagement(dashboardModel)
        });
    };

    utils.useLinkedInMp4 = function (postData) {
        // NOTE use html video tags to show older linkedin videos, before they started providing video thumbnail images
        return postData.useLinkedInMp4;
    };
});
